import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { getPointsConfigList, IPointsConfig } from '@/api/points';
import { IUSER } from './user';

/**
所有业务场景
根据您提供的格式，我将整理后的信息如下：

所有业务场景
1、专项练习 - 开始练习时消耗
* 听力
  * 听力基础场景 - 5金币
  * 听力单句独白 - 5金币
  * 听力单轮对话 - 5金币
  * 听力段落独白 - 10金币
  * 听力多轮对话 - 10金币
* 阅读
  * 阅读同义替换 - 5金币
  * 阅读定位练习 - 5金币
  * 阅读长难句理解 - 5金币
  * 阅读句子精读 - 5金币
  * 阅读扫读练习 - 5金币
* 写作
  * 写作连词成句 - 5金币
  * 写作固定搭配 - 5金币
  * 写作翻译练习 - 5金币
  * 写作语法纠错 - 5金币
  * 写作句子合并 - 5金币
  * 写作句子改写 - 5金币
2、听力真题 - 批改时消耗
* 听力剑雅真题 - 0金币
* 听力机经真题 - 10金币
3、阅读真题 - 批改时消耗
* 阅读剑雅真题 - 0金币
* 阅读机经真题 - 10金币
4、写作真题 - 批改消耗
* 审题练习 - 0金币
* 写作思路拓展 - 50金币
* 写作分段练习 - 100金币
* 写作模拟测试 - 150金币
5、模考 - 批改时消耗
* 听力模考 - 50金币
* 阅读模考 - 50金币
* 写作模考 - 250金币
6、口语 - 开始时消耗
* 口语Part 1 - 5金币
* 口语Part 2 - 10金币
* 口语Part 3 - 5金币
* 口语跟读练习 - 2金币
* 口语汉译英练习 - 5金币
* 口语合并简单句 - 5金币
* 口语模拟考试 - 150金币
 */

export const fetchPoints = createAsyncThunk('points/fetchPoints', async (_, {
  getState, rejectWithValue
}) => {
  try {
    const state = getState() as { user: IUSER; };
    if (!state.user.userPermission.isLogin) {
      return rejectWithValue(null);
    }
    const res = await getPointsConfigList();
    if (res && res.code === 200) {
      return res.data.list;
    }

    return rejectWithValue(null);

  } catch (e) {
    return rejectWithValue(null);
  }
});

export interface IPointsState {
  initialized: boolean;
  modulePoints: IPointsConfig[];
}

const initialState: IPointsState = {
  initialized: false,
  modulePoints: [],
};
export const pointsSlice = createSlice({
  name: 'points',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchPoints.fulfilled, (state, action) => {
        if (action.payload) {
          state.initialized = true;
          state.modulePoints = action.payload;
        }
      });
  },
});
export const PointsActions = {
  ...pointsSlice.actions,
  fetchPoints,
};
